import React from 'react';
import ReactLoading from 'react-loading';
import styledComponent from '../../utils/styledComponent';

const LoaderWrapper = styledComponent('div', {
  height: '28px',
  margin: '60px auto',
  width: '28px',
});

const Loader = () => (
  <LoaderWrapper>
    <ReactLoading type="spin" color="#2DB6E9" />
  </LoaderWrapper>
);

export default Loader;
